/*!

=========================================================
* Vue Now UI Dashboard PRO - v1.2.0
=========================================================

* Product Page: http://www.creative-tim.com/product/vue-now-ui-dashboard-pro
* Copyright 2019 Creative Tim (http://www.creative-tim.com)

* Designed by www.invisionapp.com Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

import Vue from "vue";

window.EventBus = new Vue();

import VueRouter from "vue-router";
import DashboardPlugin from "./dashboard-plugin";

// Plugins
import App from "./App.vue";
import store from "./store";
import swalPlugin from "./plugins/sweet-modal";
import "./plugins/mixins";
import {verifyPermissions} from "@/util/utilities";

// router setup
import routes from "./routes/routes";
import VueResource from "vue-resource";

// local support
import i18n from "./i18n";
import ElementLocale from 'element-ui/lib/locale';
/*
janeth.vazquez@kuo.com.mx
W3lcM3D3V5M1tH2020#
*/

// plugin setup
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(swalPlugin);

// Vue.use(TableColumn);

window.route = (method, endpoint = "") => {
  return [process.env.VUE_APP_API_ENDPOINT, method].join("api/");
};

Vue.http.interceptors.push(function(request) {

  // modify method
  //request.method = 'POST';

  // modify headers
  //request.headers.set('X-CSRF-TOKEN', 'TOKEN');
  //request.headers.set('Authorization', 'Bearer TOKEN');
  request.headers.set('X-Accept-Language', store.state.lang);

});

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active"
});

Vue.component('verify-permission', {
  functional: true,
  props: {
    moduleName: {
      type: String,
      default: () => null
    },
    claimName: {
      type: String,
      default: () => null
    },
    controller: {
      type: String,
      default: () => null
    },
    action: {
      type: String,
      default: () => null
    }
  },
  render: function(createElement, context)
  {
    let rols = store.state.rols;

    if(rols.length > 0){
      let permissions = rols[0].listaPermisos;
      if (verifyPermissions(permissions, context.props.controller, context.props.action))
      {
        return context.children;
      }
    }

    return '<!---->';
  }
});

router.beforeEach((to, from, next) => {
  if(to.name === "Login"){
    if(store.state.loggedIn) next({path: "/principal"});
    else next();
  }
  else if(!store.state.loggedIn){
    if(to.meta.require_auth){
      next({path: "/login"});
    }
  }

  let rols = store.state.rols;

  if(!!to.meta.controller && !!to.meta.action){
    if(rols.length > 0 && rols[0].listaPermisos != null && rols[0].listaPermisos.length > 0){
      let permissions = rols[0].listaPermisos;
      if(!verifyPermissions(permissions, to.meta.controller, to.meta.action)){
        next({
          path: "/admin/verificar_permiso?redirect="+to.fullPath
        });
      }
    }
    else {
      next({
        path: "/admin/verificar_permiso?redirect="+to.fullPath
      });
    }
  }

  next();
});

const moment = require("moment");
require("moment/locale/es");

Vue.use(require("vue-moment"), {
  moment
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  i18n,
  render: h => h(App),
  router
});

ElementLocale.i18n((key, value) => i18n.t(key, value))

// FCM config
/*
var config = {
  apiKey: "AIzaSyCBofYXI_4Q1Ui4seYMtDVNia68pOSmvZo",
  authDomain: "redi-develop.firebaseapp.com",
  databaseURL: "https://redi-develop.firebaseio.com",
  projectId: "redi-develop",
  storageBucket: "redi-develop.appspot.com",
  messagingSenderId: "78484522967",
  appId: "1:78484522967:web:d584c073025f03a367ad92",
  measurementId: "G-KS1WWZXFYZ"
};

firebase.initializeApp(config);
firebase.analytics();

Vue.prototype.$messaging = firebase.messaging()

navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
    Vue.prototype.$messaging.useServiceWorker(registration)
  }).catch(err => {
    console.log(err)
  })
*/
